import { GPC_METHODOLOGY_LOOKUP_MAP } from "./methodology-lookup";
const stationary = GPC_METHODOLOGY_LOOKUP_MAP.sectors.STATIONARY_ENERGY.energySources;
export const GPC_TRANSMISSION_DISTRIBUTION_LOSS_RATE_DEFAULTS = {
    [stationary.ELECTRICITY_GRID_LOSSES.id]: 0.05,
    [stationary.HEATING_ELECTRICITY_GRID_LOSSES.id]: 0.05,
    [stationary.DISTRICT_HEATING_GRID_LOSSES.id]: 0.12,
    [stationary.LOCAL_HEATING_GRID_LOSSES.id]: 0.12,
};
